"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _Link = _interopRequireDefault(require("../Link"));

var _excluded = ["Link"];
var Window = typeof window !== 'undefined' ? window : {};

var TrackingLink = function TrackingLink(_ref) {
  var _ref$Link = _ref.Link,
      Link = _ref$Link === void 0 ? _reactRouterDom.Link : _ref$Link,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _rest$to = rest.to,
      to = _rest$to === void 0 ? '/' : _rest$to,
      _rest$cta = rest.cta,
      cta = _rest$cta === void 0 ? {} : _rest$cta,
      dataQa = rest.dataQa;
  var external = to.split(':').length > 1;
  var href = external ? to : undefined;
  var component = external ? undefined : Link;

  var clickHandler = function clickHandler() {
    if (Window.analytics && external) {
      Window.analytics.track('bounce', {
        to: to
      });
    } else if (Window.analytics) {
      cta.element = dataQa;
      Window.analytics.track('Link click', {
        cta: cta
      });
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_Link["default"], (0, _extends2["default"])({}, rest, {
    onClick: clickHandler,
    Component: component,
    to: to,
    href: href
  }));
};

TrackingLink.propTypes = {
  to: _propTypes["default"].string.isRequired
};
var _default = TrackingLink;
exports["default"] = _default;